import { Injectable, NgZone } from '@angular/core';
import { LockScreenComponent } from './account/lock-screen/lock-screen.component';
import { ApiServiceService } from './api-service.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
private timeout: any;
  private password: string = '';
  public isAuthenticated: boolean = false;  
  public isSessionLock: boolean = false;
  private idleTimeMs = environment.idleTime;
  private isLocked:boolean=false;
  private dialogRef: MatDialogRef<LockScreenComponent> | null=null;
  employeeId:any;
  constructor(private ngZone: NgZone, private dialog: MatDialog, private apiService:ApiServiceService, private router: Router) {
    if (localStorage.getItem('SESSIONID')) {
      this.apiService
        .verifyRapidSession(localStorage.getItem('SESSIONID'))
        .subscribe(async (res: any) => {
          if (res.status) {
            if (res.data.length !== 0) {
              this.employeeId = res?.data[0]?.employeeID;
            } else {
              this.router.navigate(['login']);
            }
          } else {
            this.router.navigate(['login']);
          }
        });
    } else {
      this.router.navigate(['login']);
    }
  }

  setPassword(sessionLock:boolean) {
    this.isAuthenticated = true;
    this.isSessionLock = sessionLock
    this.initActivityListeners();    
  }

  // validatePassword(pw: string): boolean {
  //   return this.password === pw;
  // }

  validatePassword(data: number, pw: string) {
    return new Promise((resolve,reject)=>{
      this.apiService.validateUnLock(data,pw).subscribe(res=>{
        if(res){
          resolve(true);
        }else{          
          resolve(false);
        }
      })
    })
  }

  initActivityListeners() {
    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
    events.forEach(evt => window.addEventListener(evt, () => this.resetTimer()));
    this.resetTimer();
  }

  resetTimer() {
    if (this.timeout) clearTimeout(this.timeout);
    if (!this.isLocked && this.isAuthenticated){
    this.timeout = setTimeout(() => this.lockApp(), this.idleTimeMs);
    };
    // if(!this.dialogRef){
    //   this.timeout=setTimeout(()=>this.lockApp(), this.idleTimeMs)
    // }
  }

  lockApp() {
    if(!this.isSessionLock || this.isLocked || !this.isAuthenticated || this.dialogRef) return;
    this.isLocked=true;
    this.ngZone.run(() => {
      sessionStorage.setItem('locked','true');
      const dialogRef = this.dialog.open(LockScreenComponent, {
        disableClose: true,
        width: '100vw',
        height: '80vh',
        autoFocus: true,
        restoreFocus:false,
        panelClass: 'lock-modal',
        backdropClass: 'blur-backdrop',
        data: this.employeeId 
      });      
      this.dialogRef = dialogRef;
      dialogRef!.afterClosed().subscribe(()=>{
        this.dialogRef= null;
        this.isLocked=false;
        this.resetTimer();
      })
    });
  }
}
